'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { RoomCardSkeleton } from '@/app/[locale]/(worlds)/(worlds-landing)/search/components/RoomCard';
import SearchResultNativeAd from '@/app/[locale]/(worlds)/(worlds-landing)/search/components/SearchResultNativeAd';
import SectionHeader from '@/app/[locale]/(worlds)/(worlds-landing)/search/components/SectionHeader';
import { SearchContentType, useWorldsSearch } from '@/app/[locale]/(worlds)/(worlds-landing)/search/components/useWorldsSearch';
import WorldsListItem from '@/app/[locale]/(worlds)/(worlds-landing)/search/components/WorldsListItem';
import { LoadingDots } from '@/components/LoadingDots';
import { ViverseWorldCardSkeleton } from '@/components/ViverseWorldCardSkeleton';
import { cn } from '@/lib/utils';
type WorldsListProps = {
  enablePagination: boolean;
  contentType: SearchContentType;
  showNativeAd: boolean;
};
const TITLE_KEY: Record<SearchContentType, string> = {
  games: 'worlds-landing.search.tabs.games',
  experiences: 'worlds-landing.search.tabs.experiences',
  videos: 'media-browser.nav_title.videos'
};
export default function WorldsList(t0) {
  const $ = _c(32);
  const {
    enablePagination,
    contentType,
    showNativeAd
  } = t0;
  const t = useTranslations();
  const {
    allItems,
    isPending,
    isLoading,
    isValidating,
    isRouteLoading,
    enableLoadMore,
    loadMoreRef
  } = useWorldsSearch(contentType, enablePagination);
  if (!isPending && allItems.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== allItems || $[1] !== contentType || $[2] !== enablePagination || $[3] !== isPending || $[4] !== isRouteLoading || $[5] !== showNativeAd) {
    t1 = () => {
      const isShowingSkeleton = isRouteLoading || isPending;
      if (isShowingSkeleton && !enablePagination) {
        return Array.from({
          length: 3
        }).map(_temp);
      }
      if (isShowingSkeleton) {
        return Array.from({
          length: 20
        }).map(_temp2);
      }
      const items = allItems.map((world, i_1) => <WorldsListItem key={`${world.id}-${i_1}`} world={world} enablePagination={enablePagination} contentType={contentType} />);
      if (showNativeAd && items.length > 0) {
        items.splice(1, 0, <SearchResultNativeAd key="search-result-native-ad" />);
      }
      return items;
    };
    $[0] = allItems;
    $[1] = contentType;
    $[2] = enablePagination;
    $[3] = isPending;
    $[4] = isRouteLoading;
    $[5] = showNativeAd;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  const renderItems = t1;
  const t2 = TITLE_KEY[contentType];
  let t3;
  if ($[7] !== t || $[8] !== t2) {
    t3 = t(t2);
    $[7] = t;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t3) {
    t4 = <SectionHeader title={t3} viewAllHref="/#explore-viverse" />;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const t5 = !enablePagination;
  let t6;
  if ($[12] !== enablePagination || $[13] !== t5) {
    t6 = cn("relative flex gap-2", {
      "flex-col lg:gap-5": t5,
      "1.5xl:grid-cols-[repeat(auto-fill,minmax(240px,1fr))] grid grid-cols-2 gap-4 md:grid-cols-[repeat(auto-fill,minmax(200px,1fr))] md:gap-6": enablePagination
    });
    $[12] = enablePagination;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== renderItems) {
    t7 = renderItems();
    $[15] = renderItems;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== t6 || $[18] !== t7) {
    t8 = <div className={t6}>{t7}</div>;
    $[17] = t6;
    $[18] = t7;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== enableLoadMore || $[21] !== loadMoreRef) {
    t9 = enableLoadMore && <div ref={loadMoreRef} className="h-4" />;
    $[20] = enableLoadMore;
    $[21] = loadMoreRef;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== enablePagination || $[24] !== isLoading || $[25] !== isValidating) {
    t10 = (isLoading || isValidating) && enablePagination && <LoadingDots />;
    $[23] = enablePagination;
    $[24] = isLoading;
    $[25] = isValidating;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  let t11;
  if ($[27] !== t10 || $[28] !== t4 || $[29] !== t8 || $[30] !== t9) {
    t11 = <div className="flex flex-col gap-4 lg:gap-5">{t4}{t8}{t9}{t10}</div>;
    $[27] = t10;
    $[28] = t4;
    $[29] = t8;
    $[30] = t9;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  return t11;
}
function _temp2(__0, i_0) {
  return <ViverseWorldCardSkeleton key={i_0} className="aspect-video h-auto p-0" />;
}
function _temp(_, i) {
  return <RoomCardSkeleton key={i} />;
}